module.exports = __webpack_public_path__ + "static/media/Forgotten1.be86253f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Characters/Forgotten1.jpg
// module id = 191
// module chunks = 0